<template>
  <v-chip
    v-if="type === 'chip'"
    pill
    :close="!!user"
    :disabled="disabled"
    v-on="$listeners"
  >
    <v-avatar
      left
      color="primary"
    >
      <v-img
        v-if="photoURL"
        :src="photoURL"
        :alt="displayName"
        :aspect-ratio="1"
        contain
      />

      <span
        v-else-if="displayName"
        class="white--text"
      >
        {{ nameInitials }}
      </span>

      <v-icon v-else>
        {{ icon }}
      </v-icon>
    </v-avatar>

    <span v-if="displayName">{{ displayName }}</span>
    <em v-else>{{ noUserText }}</em>
  </v-chip>

  <component
    :is="componentName"
    v-else
    :color="image ? null : 'primary'"
    :size="size > 0 ? size : (type === 'avatar' ? (large ? 100 : 48) : 40)"
    v-on="$listeners"
  >
    <v-img
      v-if="photoURL"
      :src="photoURL"
      :alt="displayName"
      :aspect-ratio="1"
      contain
    />

    <span
      v-else-if="displayName"
      class="white--text"
      :style="{ fontSize: size <= 20 ? '80%' : '100%' }"
    >
      {{ nameInitials }}
    </span>

    <v-icon v-else>
      {{ icon }}
    </v-icon>
  </component>
</template>

<script>
import { VAvatar, VListItemAvatar } from 'vuetify/lib'
import { mapGetters } from 'vuex'

export default {
  components: {
    VAvatar,
    VListItemAvatar
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: 'account_circle'
    },
    large: {
      type: Boolean,
      default: false
    },
    noUserText: {
      type: String,
      default: 'No user'
    },
    size: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: 'list',
      validator (val) {
        return ['avatar', 'chip', 'list'].indexOf(val) > -1
      }
    }
  },
  computed: {
    ...mapGetters([ 'getUserById' ]),

    user () {
      return this.userId ? this.getUserById(this.userId) : null
    },
    componentName () {
      return this.type === 'list' ? 'v-list-item-avatar' : 'v-avatar'
    },
    photoURL () {
      return this.user && this.user.profile ? this.user.profile.photoURL : this.image
    },
    displayName () {
      if (this.user) {
        return this.user.profile ? this.user.profile.displayName : this.user.email
      } else {
        return this.name
      }
    },
    nameInitials () {
      const names = this.displayName.split(' ')
      let initials = names[0][0]

      if (names.length > 1) {
        initials += names[names.length - 1][0]
      }

      return initials.toLocaleUpperCase()
    }
  }
}
</script>

<style>

</style>
